import { Routes } from '@angular/router';

import { authChildGuard, authGuard, loggedInGuard } from '@core/guards/auth';
import { availabilityChildGuard, isAvailableGuard } from '@core/guards/availability';
import { nutrientProgramReadyChildGuard } from '@core/guards/nutrient-program-ready';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./tabs/tabs-routes').then((m) => m.routes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth-routes').then((m) => m.routes)
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding-routes').then((m) => m.routes)
  },
  {
    path: 'outside-area',
    canActivate: [authGuard, isAvailableGuard],
    loadComponent: () => import('./outside-area/outside-area/outside-area').then((m) => m.OutsideArea)
  },
  {
    path: 'nutrient-program',
    canActivateChild: [authChildGuard, availabilityChildGuard, nutrientProgramReadyChildGuard],
    loadChildren: () => import('./nutrient-program/nutrient-program-routes').then((m) => m.routes)
  },
  {
    path: 'on-demand',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./on-demand/on-demand-routes').then((m) => m.routes)
  },
  {
    path: 'menu',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./menu/menu-routes').then((m) => m.routes)
  },
  {
    path: 'payment',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./payment/payment-routes').then((m) => m.routes)
  },
  {
    path: 'order',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./order/order-routes').then((m) => m.routes)
  },
  {
    path: 'settings',
    canActivateChild: [authChildGuard],
    loadChildren: () => import('./settings/settings-routes').then((m) => m.routes)
  },
  {
    path: 'experience-results',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./experience-results/experience-results-routes').then((m) => m.routes)
  },
  {
    path: 'wellness-results',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./wellness-results/wellness-results-routes').then((m) => m.routes)
  },
  {
    path: 'experiences',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./experiences/experiences-routes').then((m) => m.routes)
  },
  {
    path: 'pending-reviews',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./pending-reviews/pending-reviews-routes').then((m) => m.routes)
  },
  {
    path: 'health-sharing',
    canActivateChild: [authChildGuard, availabilityChildGuard],
    loadChildren: () => import('./health-sharing/health-sharing-routes').then((m) => m.routes)
  },
  {
    // Render the Login component directly here rather than redirecting to 'auth/login'. This is the OAuth
    // web redirect_uri (origin/login); the GenericOAuth2 popup matches the callback URL by substring against
    // 'origin/login', so redirecting to '/auth/login' changed the URL out from under it and intermittently
    // dropped the code (popup never closed). Keeping the URL at '/login' makes the match reliable.
    path: 'login',
    canActivate: [loggedInGuard],
    loadComponent: () => import('./auth/login/login').then((m) => m.Login)
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];
